exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.orderNav{border-top:1px solid #212a32\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/layout/leftnav/orderNav.vue"],"names":[],"mappings":";AAuDA,UACE,4BAAqC;CACtC","file":"orderNav.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.orderNav {\n  border-top: 1px solid rgb(33, 42, 50);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3361b7cd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/leftnav/orderNav.vue
// module id = HVHC
// module chunks = 2